import { Dispatch, SetStateAction, useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import {
  useShowingNewsSubscription$data,
  useShowingNewsSubscription as useShowingNewsSubscriptionType,
} from "@/modules/admin/news/services/__generated__/useShowingNewsSubscription.graphql"

const subscription = graphql`
  subscription useShowingNewsSubscription {
    showingNews {
      createdAt
      criticalityLevel
      displayFor
      endTime
      englishContent
      frenchContent
      germanContent
      id
      isShowing
      italianContent
      startTime
    }
  }
`

const useShowingNewsSubscription = (
  setNewsBannerList: Dispatch<SetStateAction<useShowingNewsSubscription$data | null | undefined>>,
) => {
  const subscriptionConfig: GraphQLSubscriptionConfig<useShowingNewsSubscriptionType> = useMemo(
    () => ({
      variables: {},
      subscription,
      onError: (error: Error) => console.error(`An error occurred while subscribe to ShowingNews:`, error),
      onNext(response) {
        setNewsBannerList(response)
      },
    }),
    [setNewsBannerList],
  )

  return useSubscription<useShowingNewsSubscriptionType>(subscriptionConfig)
}

export { useShowingNewsSubscription }
